import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = () => {
    const router = inject(Router);
    const authService = inject(AuthService);

    return authService.check().pipe(
        switchMap((authenticated) => {
            if (authenticated) {
                const userData = localStorage.getItem('user');
                let redirectUrl = '/cliente/home';

                if (userData) {
                    const user = JSON.parse(userData);
                    const roles: string[] = user?.roles ?? [];

                    if (roles.includes('Administrador')) {
                        redirectUrl = '/admin/home';
                    } else if (roles.includes('Cliente')) {
                        redirectUrl = '/cliente/home';
                    }
                }

                return of(router.parseUrl(redirectUrl));
            }

            return of(true);
        })
    );
};